import { Auth } from '@core/auth';

import permissions from '@constants/enums/auth/permission';

import i18n from '@plugins/i18n';

import TransactionsSidebar from '@/components/sidebars/TransactionsSidebar.vue';
import Organisation from '@/models/Organisation';

export default [
    {
        path: '/portfolio',
        name: 'Portfolio',
        component: () => import('@/views/Portfolio.vue'),
        redirect: {
            name: 'PortfolioDashboard'
        },
        children: [
            {
                path: 'dashboard',
                name: 'PortfolioDashboard',
                component: () => import('@/views/PortfolioDashboard.vue'),
                meta: {
                    overline: i18n.t('portfolio'),
                    title: i18n.t('_page.portfolio_dashboard.heading'),
                    heading: i18n.t('_page.portfolio_dashboard.heading'),
                    description: i18n.t('_page.portfolio_dashboard.description'),
                    organisations: ['ADVISER', 'INVESTOR', 'FUND_MANAGER', 'PRODUCT_PROVIDER'],
                    retainQuerySelectors: ['investor_id']
                }
            },
            {
                path: 'detail',
                name: 'PortfolioDetail',
                component: () => import('@/views/PortfolioDetail.vue'),
                redirect: {
                    name: 'PortfolioDetailSummary'
                },
                meta: {
                    overline: i18n.t('portfolio'),
                    title: i18n.t('_page.portfolio_detail.heading'),
                    heading: i18n.t('_page.portfolio_detail.heading'),
                    description: i18n.t('see_tabs_of_all_display_sections'),
                    organisations: ['ADVISER', 'INVESTOR', 'FUND_MANAGER', 'PRODUCT_PROVIDER'],
                    retainQuerySelectors: ['investor_id']
                },
                children: [
                    {
                        path: 'summary',
                        name: 'PortfolioDetailSummary',
                        component: () => import('@/views/PortfolioDetailSummary.vue'),
                        meta: {
                            overline: i18n.t('portfolio'),
                            title:
                                i18n.t('_page.portfolio_detail.heading') +
                                ' - ' +
                                i18n.t('_page.portfolio_detail.summary.heading'),
                            heading: i18n.t('_page.portfolio_detail.summary.heading'),
                            organisations: ['ADVISER', 'INVESTOR', 'FUND_MANAGER', 'PRODUCT_PROVIDER'],
                            retainQuerySelectors: ['investor_id']
                        }
                    },
                    {
                        path: 'single-company',
                        name: 'PortfolioDetailSingleCompany',
                        component: () => import('@/views/PortfolioDetailSingleCompany.vue'),
                        meta: {
                            overline: i18n.t('portfolio'),
                            title:
                                i18n.t('_page.portfolio_detail.heading') +
                                ' - ' +
                                i18n.t('_page.portfolio_detail.single_company.heading'),
                            heading: i18n.t('_page.portfolio_detail.single_company.heading'),
                            organisations: ['ADVISER', 'INVESTOR', 'FUND_MANAGER', 'PRODUCT_PROVIDER'],
                            retainQuerySelectors: ['investor_id']
                        }
                    },
                    {
                        path: 'eis-seis',
                        name: 'PortfolioDetailEisSeis',
                        component: () => import('@/views/PortfolioDetailEisSeis.vue'),
                        meta: {
                            overline: i18n.t('portfolio'),
                            title:
                                i18n.t('_page.portfolio_detail.heading') +
                                ' - ' +
                                i18n.t('_page.portfolio_detail.eis_seis.heading'),
                            heading: i18n.t('_page.portfolio_detail.eis_seis.heading'),
                            organisations: ['ADVISER', 'INVESTOR', 'FUND_MANAGER', 'PRODUCT_PROVIDER'],
                            retainQuerySelectors: ['investor_id']
                        }
                    },
                    {
                        path: 'vct',
                        name: 'PortfolioDetailVct',
                        component: () => import('@/views/PortfolioDetailVct.vue'),
                        meta: {
                            overline: i18n.t('portfolio'),
                            title:
                                i18n.t('_page.portfolio_detail.heading') +
                                ' - ' +
                                i18n.t('_page.portfolio_detail.vct.heading'),
                            heading: i18n.t('_page.portfolio_detail.vct.heading'),
                            organisations: ['ADVISER', 'INVESTOR', 'FUND_MANAGER', 'PRODUCT_PROVIDER'],
                            retainQuerySelectors: ['investor_id']
                        }
                    },
                    {
                        path: 'iht',
                        name: 'PortfolioDetailIht',
                        component: () => import('@/views/PortfolioDetailIht.vue'),
                        meta: {
                            overline: i18n.t('portfolio'),
                            title:
                                i18n.t('_page.portfolio_detail.heading') +
                                ' - ' +
                                i18n.t('_page.portfolio_detail.iht.heading'),
                            heading: i18n.t('_page.portfolio_detail.iht.heading'),
                            organisations: ['ADVISER', 'INVESTOR', 'FUND_MANAGER', 'PRODUCT_PROVIDER'],
                            retainQuerySelectors: ['investor_id']
                        }
                    },
                    {
                        path: 'pmi',
                        name: 'PortfolioDetailPmi',
                        component: () => import('@/views/PortfolioDetailPmi.vue'),
                        meta: {
                            overline: i18n.t('portfolio'),
                            title:
                                i18n.t('_page.portfolio_detail.heading') +
                                ' - ' +
                                i18n.t('_page.portfolio_detail.pmi.heading'),
                            heading: i18n.t('_page.portfolio_detail.pmi.heading'),
                            organisations: ['ADVISER', 'INVESTOR', 'FUND_MANAGER', 'PRODUCT_PROVIDER'],
                            retainQuerySelectors: ['investor_id']
                        }
                    }
                ]
            },
            {
                path: 'client-registrations',
                name: 'PortfolioClientRegistrations',
                component: () => import('@/views/PortfolioClientRegistrations.vue'),
                meta: {
                    overline: i18n.t('portfolio'),
                    title: i18n.t('_page.client_registrations.heading'),
                    heading: i18n.t('_page.client_registrations.heading'),
                    permissions: [permissions.INVESTOR_READ],
                    organisations: ['ADVISER'],
                    retainQuerySelectors: ['investor_id']
                }
            },
            {
                path: 'clients',
                name: 'PortfolioClients',
                component: () => import('@/views/PortfolioClients.vue'),
                meta: {
                    overline: i18n.t('portfolio'),
                    title: i18n.t('_page.clients.heading'),
                    heading: i18n.t('_page.clients.heading'),
                    organisations: ['ADVISER', 'FUND_MANAGER', 'PRODUCT_PROVIDER']
                }
            }
        ]
    },
    {
        path: '/accounts',
        name: 'Accounts',
        components: {
            default: () => import('@/views/Accounts.vue')
        },
        meta: {
            overline: i18n.t('portfolio'),
            title: i18n.t('cash_and_fees'),
            heading: i18n.t('cash_and_fees'),
            organisations: ['ADVISER', 'INVESTOR'],
            retainQuerySelectors: ['investor_id']
        }
    },
    {
        path: '/transactions',
        name: 'Transactions',
        components: {
            default: () => import('@/views/Transactions.vue'),
            sidebar: {
                active: () => {
                    const auth = Auth();

                    if (auth.is_fund_manager || auth.is_provider) {
                        let org = auth.organisation;

                        if (org) {
                            org = org instanceof Organisation ? org : new Organisation(org);

                            if (!org.hasTierAccess(2)) {
                                return false;
                            }
                        }
                    }

                    return true;
                },
                render(h) {
                    return h(TransactionsSidebar);
                }
            }
        },
        meta: {
            title: i18n.t('transactions'),
            heading: i18n.t('transactions'),
            organisations: ['ADVISER', 'INVESTOR', 'FUND_MANAGER', 'PRODUCT_PROVIDER'],
            retainQuerySelectors: ['investor_id'],
            sidebarKey: 'transactions-sidebar'
        }
    }
];
